import React, { useState, useEffect } from 'react';
import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const RailplusModal = ({ callbackEvent, onClose }) => {

  const [count, setCount] = useState(10);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    console.log("ADD");
    document.addEventListener("backpress", callbackEvent);
    document.addEventListener("railplus", callbackEvent);

    return () => {
      console.log("REMOVE");
      document.removeEventListener("backpress", callbackEvent);
      document.removeEventListener("railplus", callbackEvent);
    }
  }, [callbackEvent]);

  useEffect(() => {
    const countdown = setTimeout(() => {
      console.log(count);
      setCount(count - 1);
    }, 1000);

    if (count === 0) {
      console.log("TIMEOUT");
      onClose(true);
    }

    return () => clearTimeout(countdown);
  }, [count, onClose]);
  
  return (
    <ReactModal isOpen={true} contentLabel="modal" onRequestClose={onClose} className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
      <p className="tit">10초 이내에 터치!</p>
      <span>{count}</span>
      <div className="btnWrapTy02">
        <button type="button" className="btnPrimaryTy03" onClick={onClose}><span>Close</span></button>
      </div>
    </ReactModal>
  );
}

export default RailplusModal;